/**
 * Docs base URL for the app, imported by both client and server. Local docs when
 * `NODE_ENV=development`, production origin otherwise. `NODE_ENV` is inlined into
 * the browser bundle, so client and server resolve the same origin.
 */
const isDev = process.env.NODE_ENV === "development";

/** Absolute origin the docs site is served from. */
export const DOCS_ORIGIN = isDev ? "http://localhost:4321" : "https://medblocks.com";

/**
 * Builds an absolute URL to a docs page from a root-relative path.
 * @param path root-relative docs path such as "/docs/mcp"
 * @returns the absolute docs URL under {@link DOCS_ORIGIN}
 */
export function docsUrl(path: string): string {
  return `${DOCS_ORIGIN}${path}`;
}

/**
 * Absolute origin the marketing site is served from, where the terms and privacy
 * pages live. It is fixed in every environment, because there is no local
 * marketing server to fall back to and a dev-only origin would point a legal
 * link at a 404.
 */
export const SITE_ORIGIN = "https://medblocks.com";

/**
 * Builds an absolute URL to a marketing-site page from a root-relative path.
 * Use this for `/terms` and `/privacy`; {@link docsUrl} is for the docs site.
 * @param path root-relative site path such as "/terms"
 * @returns the absolute URL under {@link SITE_ORIGIN}
 */
export function siteUrl(path: string): string {
  return `${SITE_ORIGIN}${path}`;
}
